export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-speedometer',
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Benutzer']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Dienstleister',
        to: '/dashboard/users/list/service',
        icon: 'cil-cloud-download',
      },

      {
        _name: 'CSidebarNavItem',
        name: 'Kunden',
        to: '/dashboard/users/list/customer',
        icon: 'cil-user',
      },

      {
        _name: 'CSidebarNavTitle',
        _children: ['Verwaltung']
      },
     /* {
        _name: 'CSidebarNavItem',
        name: 'Rechte',
        to: '/dashboard/users/permissions',
        icon: 'cil-settings',
      },

      */
      {
        _name: 'CSidebarNavItem',
        name: 'Rollen',
        to: '/dashboard/users/roles',
        icon: 'cil-settings',
      },
        /*
      {
        _name: 'CSidebarNavItem',
        name: 'Neu',
        to: '/dashboard/shops/new',
        icon: 'cil-basket',
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Produkte']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Import',
        to: '/dashboard/products/import',
        icon: 'cil-cloud-download'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Importierte Produkte',
        to: '/dashboard/products/list',
        icon: 'cil-cloud-download'
      }
         */
    ]
  }
  ]
